export function Lessons() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
      <rect width="48" height="48" fill="none"/>
      <path d="M41.05,15H7.95c-1.1,0-2-.9-2-2s.9-2,2-2h33.1c1.1,0,2,.9,2,2s-.9,2-2,2Z" fill="currentColor"/>
      <path d="M34,24H7.71c-1.1,0-2-.9-2-2s.9-2,2-2h26.29c1.1,0,2,.9,2,2s-.9,2-2,2Z" fill="currentColor"/>
      <path d="M25.24,33H7.71c-1.1,0-2-.9-2-2s.9-2,2-2h17.53c1.1,0,2,.9,2,2s-.9,2-2,2Z" fill="currentColor"/>
    </svg>
  );
}